// @ts-nocheck
import { useContext, useMemo, useState } from "react";
import { CheckCircleOutlined, CheckSquareOutlined, DownloadOutlined } from "@ant-design/icons";
import { Button, Checkbox, Flex, Space, Typography } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import DOMPurify from "dompurify";
import useContract from "../hooks/apis/useContract";
import Loading from "../components/loading";
import Error from "../components/error";
import DownloadContract from "../components/downloadContract";
import OTPModal from "../components/OTPModal";
import useSignContract from "../hooks/apis/useSignContract";
import { AppContext } from "../constants/contexts";
import { getErrorMessage } from "../utils/http";
import useContracts from "../hooks/apis/useContracts";
import { useMobileNavTitle } from "../components/MobileTopNav";

const { Title, Text } = Typography;

function Contract() {
  const { messageApi } = useContext(AppContext);
  const { uuid } = useParams<{ uuid: string }>();
  const { data: contract, isLoading: contractLoading, error } = useContract(uuid);
  const { mutate: refetchContracts } = useContracts()
  const signMutation = useSignContract();
  const [isAgreed, setIsAgreed] = useState(false);
  const [isOTPModalOpen, setIsOTPModalOpen] = useState(false);
  const navigate = useNavigate()
  useMobileNavTitle(contract?.title);
  const sanitizedContent = useMemo(
    () => (contract?.content ? DOMPurify.sanitize(contract.content) : ""),
    [contract?.content]
  );

  if (contractLoading) {
    return <Loading size="fill" text="در حال بارگذاری..." />;
  }

  if (error || !contract) {
    return (
      <Error
        size="fill"
        text="خطا در بارگذاری قرارداد"
        iconClassName="text-[red]"
        textClassName="text-[red] mt-2 text-2xl"
      />
    );
  }



  if (contract.status === 'SIGNED')
    return (
      <div className="p-1 lg:p-8 mx-auto max-w-6xl">
        <div style={{ width: "100%" }}>
          <Space orientation="vertical" size="small" style={{ width: "100%", textAlign: "center" }}>
            <CheckCircleOutlined style={{ fontSize: "64px", color: "#52c41a" }} />
            <Title level={2}>{contract.title}</Title>
            <Text style={{ fontSize: "16px" }}>
              این قرارداد در تاریخ {new Date(contract.signedAt).toLocaleDateString("fa-IR")} امضا شده است.
            </Text>
            <Link to="/settings">
              <Button variant="link" title="بازگشت" >بازگشت</Button>
            </Link>
          </Space>
        </div>
      </div>
    );
  return (
    <div className="p-1 lg:p-8 mx-auto max-w-6xl">
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <Title level={2}>{contract.title}</Title>


        <div
          dangerouslySetInnerHTML={{ __html: sanitizedContent }}
          className="border-solid border-2 p-4 rounded-md border-[#d9d9d9] bg-white dark:bg-gray-800"
        />

        {contract.hash && (
          <Typography.Paragraph type="secondary" code style={{ textAlign: 'left' }}>
            Hash: {contract.hash}
          </Typography.Paragraph>
        )}
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          <Checkbox checked={isAgreed} onChange={(e) => setIsAgreed(e.target.checked)}>
            قرارداد را خوانده‌ام و شرایط آن را پذیرفته‌ام
          </Checkbox>

          <Flex gap={8}>
            <DownloadContract uuid={uuid || ""} title="دانلود PDF قرارداد" />
            <Button
              icon={<CheckSquareOutlined />}
              onClick={() => setIsOTPModalOpen(true)} type="primary" size="large" disabled={!isAgreed}>
              امضا دیجیتال قرارداد
            </Button>
          </Flex>

        </Space>
      </Space>
      <OTPModal
        type="CONTRACT_SIGNING"
        url={`/contracts/${contract.uuid}/sign`}
        payload={{}}
        requestOtp
        open={isOTPModalOpen}
        onClose={() => {
          setIsOTPModalOpen(false);
        }}
        onSuccess={() => {
          setIsOTPModalOpen(false);
          messageApi.open({
            type: "success",
            content: "قرارداد با موفقیت امضا شد",
          });
          refetchContracts()
          navigate('/settings')
        }}
      />
    </div>
  );
}

export default Contract;

